<template>
    <CollectionLayout
        :is-collection-partner-visma="isCollectionPartnerVisma"
    >
        <DCard padding>
            <DTable
                :items="items"
                :fields="fields"
                hover
            >
                <template #invoiceId="{item}">
                    <td>
                        <Link
                            v-if="userPermissions.includes('customer.view')"
                            :href="customerProfileRoute(item.customerId)"
                        >
                            {{ item.customerId }}
                        </Link>
                        <span v-else>
                            {{ item.customerId }}
                        </span>
                        <Link
                            v-if="userPermissions.includes('invoice.view')"
                            :href="invoiceRoute(item)"
                        >
                            ({{ item.invoiceId }})
                        </Link>
                        <span v-else>
                            ({{ item.invoiceId }})
                        </span>
                    </td>
                </template>
                <template #error="{item}">
                    <td style="max-width: 10rem;">
                        <span v-if="item.error !== null">
                            {{ $page.props.auth.user.language_code === 'de' ? item.error.message_de : item.error.message_en }}
                            <Link
                                v-if="userPermissions.includes('task.manage')"
                                :href="item.error.link"
                            >
                                ({{ item.error.task_id }})
                            </Link>
                        </span>
                    </td>
                </template>
            </DTable>
            <DPagination
                v-if="batches.last_page >= 1"
                :active-page="batches.current_page"
                :pages="batches.last_page"
                align="center"
                @update:activePage="changePage"
            />
        </DCard>
    </CollectionLayout>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { router, usePage } from '@inertiajs/vue3'
import { __ } from '~@/Composables/translation'
import { computed } from 'vue'
import CollectionLayout from '~@/Pages/Tools/Collection/Layout.vue'

const props = defineProps({
    items: {
        type: Array,
        default: () => {
            return []
        }
    },
    batches: {
        type: Object,
        default: () => {
            return {}
        }
    },
    batch: {
        type: Object,
        default: () => {
            return {}
        }
    },
    isCollectionPartnerVisma: {
        type: Boolean,
        default: () => {
            return false
        }
    }
})

let fields = [
    { key: 'id', label: __('tools.batches.id') },
    { key: 'invoiceId', label: __('tools.batches.customer_invoice') },
    { key: 'debtLoss', label: __('tools.batches.debt_loss') },
    { key: 'error', label: __('tools.batches.error') }
]

if (props.isCollectionPartnerVisma === true) {
    fields = [...fields, { key: 'api_status', label: __('tools.batches.api_status') }]
}

const userPermissions = computed(() => usePage().props.auth.permissions)

const customerProfileRoute = (id) => route('customers.customers.show', id)
const invoiceRoute = (value) => route('customers.customers.invoices.show', {
    customer: value.customerId,
    invoice: value.invoiceId
})

const changePage = (page) => {
    const query = {}
    if (page > 1) {
        query.page = page
    }
    router.get(route('tools.collection.show', { batch: props.batch.id }), query)
}

</script>

<style scoped lang="scss">

</style>
